// File: pages/RepayLoan.js

import React from 'react';
import RepayLoanComponent from '../components/repay-loan';

const RepayLoan = () => {
  return <RepayLoanComponent />;
};

export default RepayLoan;
